import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-arrow-right\"><path d=\"M21.715 11.388l-9.752-8.29A.419.419 0 0011.692 3H9.407c-.19 0-.279.233-.134.354l9.04 7.685H3.207a.205.205 0 00-.207.203v1.516c0 .112.093.203.207.203H18.31l-9.04 7.685a.2.2 0 00.134.354h2.362a.2.2 0 00.134-.05l9.814-8.338A.813.813 0 0022 12a.797.797 0 00-.285-.612z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol